import React from 'react';
import coded from './img/coded.png';
import miracle from './img/miracle.png';
import mangoes from './img/mango.png';
import popoola from './img/popo.png';
import contact from './img/contact.png';
import mcontact from './img/mobileCont.png';

function Meet() {
	return (
		<div id="team-10123">
			<h2 id="hala-10123">
				Meet Our <span id="blue-10123">Team</span>
			</h2>
			<p id="duh-10123">
				We have a team of developers from all stacks, devoted to helping you
				debug your next project
			</p>

			<div id="main-container-10123">
				<div id="image-container-10234">
					<img id="img-self-10123" src={coded} alt="" />
					<div id="text-container-10123">
						<p id="role-10123">Front-end team lead </p>
						<h4 id="name-10123">CoddedLibra </h4>
					</div>
				</div>
				<p id="text-wrap-10123">
					<span id="question-bold-10123">What do you do at DevAsk ? </span>I am
					the FRONTEND TEAMLEAD at DevAsk, as the FE LEAD it is my job to bridge
					the gap between all devs team members and other non developers members
					of the team and to organise FRONT END technical team members towards
					the whole team`&apos;`s goals. It is also my job to answer FRONTEND
					technical questions about our team posed by the CTO & PM. I also
					translate general requirements and instructions to technical
					instructions and tickets that my FRONT END teams can understand and
					carry out effectively and timelyWhat does a typical day working on
					DevAsk look like?Meetings. Research. More meetings. Changing
					deadlines, mean when necessary and work.
				</p>

				<p id="text-wrap-10123">
					<span id="question-bold-10123">
						When you are not working, what do you enjoy doing ?
					</span>
					I watch Netflix, hangout with friends, and I learn new stuffs,
				</p>

				<p id="text-wrap-10123">
					<span id="question-bold-10123">
						What is the one thing you have learnt working on DevAsk ?
					</span>
					It`&apos;`s better to have a small team that is durable and efficient
					towards our goals than to have a large team. Also, team spirit,
					positivity, dedication and clarity are so important to your team.
				</p>

				<p id="text-wrap-10123">
					<span id="question-bold-10123">
						How would you describe what you do to a 5Y/O ?
					</span>
					I`&apos;`m helping front end Developers on this team wrote codes that changes
					to a fine layout and non-Developers understand and work together.
				</p>
				<img id="cont-10123" src={contact} alt="web contact" />
				<img id="mcont-10123" src={mcontact} alt="mobile contacts" />
			</div>

			<div id="main-container-10123">
				<div id="image-container-10234">
					<img id="img-self-10123" src={miracle} alt="ss" />
					<div id="text-container-10123">
						<p id="role-10123">CTO </p>
						<h4 id="name-10123"> Miracle Ufodinma </h4>
					</div>
				</div>
				<p id="text-wrap-10123">
					<span id="question-bold-10123">What do you do at DevAsk?</span>I am
					the CTO at DevAsk, as the CTO it is my job to bridge the gap between
					technical team members and other members of the team and to organise
					technical team members towards the whole team`&apos;`s goals. It is
					also my job to answer technical questions about our team posed by the
					PM. I also translate general requirements and instructions to
					technical instructions and tickets that my technical people can
					understand and carry out.
				</p>

				<p id="text-wrap-10123">
					<span id="question-bold-10123">
						What does a typical day working on DevAsk look like?
					</span>
					Meetings. Research. More meetings. Changing deadlines and fast
					work.When you are not working, what do you enjoy doing?I sleep. I eat.
					I learn new stuff.
				</p>

				<p id="text-wrap-10123">
					<span id="question-bold-10123">
						What is the one thing you have learnt working on DevAsk?
					</span>
					It`&apos;`s better to have a small team that is lean and sharp towards our
					goals than to have a large team. Also, constant communication and
					clarity are so important no matter the size of your team.
				</p>

				<p id="text-wrap-10123">
					<span id="question-bold-10123">
						How would you describe what you do to a 5Y/O?
					</span>
					I`&apos;`m helping Developers on this team and non-Developers work together.
				</p>
				<img id="cont-10123" src={contact} alt="web contact" />
				<img id="mcont-10123" src={mcontact} alt="mobile contacts" />
			</div>

			<div id="main-container-10123">
				<div id="image-container-10234">
					<img id="img-self-10123" src={popoola} alt="" />
					<div id="text-container-10123">
						<p id="role-10123">Product manager </p>
						<h4 id="name-10123">Taiwo Ayodeji popoola </h4>
					</div>
				</div>
				<p id="text-wrap-10123">
					<span id="question-bold-10123">What do you do at DevAsk?</span>
					I`&apos;`m Product manager with team Mallet. I supervise the marketing team
					project .
				</p>

				<p id="text-wrap-10123">
					<span id="question-bold-10123">
						What does a typical day working on DevAsk look like?
					</span>
					Liaising with the team leads on progress made, resolution of issues
					highlighted and attending meetings pertaining to the project.
				</p>
				<p id="text-wrap-10123">
					<span id="question-bold-10123">
						When you are not working, what do you enjoy doing?
					</span>
					I watch football, read news headlines, play a little bit of call of
					duty
				</p>
				<p id="text-wrap-10123">
					<span id="question-bold-10123">
						What is the one thing you have learnt working on DevAsk?{' '}
					</span>
					Collaboration is crucial to success. I`&apos;`ve learnt to hear from
					all sides in a situation and ensure everybody is carried along.
				</p>
				<img id="cont-10123" src={contact} alt="web contact" />
				<img id="mcont-10123" src={mcontact} alt="mobile contacts" />
			</div>
			<div id="main-container-10123">
				<div id="image-container-10234">
					<img id="img-self-10123" src={mangoes} alt=" " />
					<div id="text-container-10123">
						<p id="role-10123">Marketing team lead</p>
						<h4 id="name-10123">Mangoes </h4>
					</div>
				</div>
				<p id="text-wrap-10123">
					<span id="question-bold-10123">What do you do at DevAsk?</span>I am
					the Marketing Team Lead at DevAsk. I’m in charge of delegating tasks
					to the Marketers in our team.
				</p>
				<p id="text-wrap-10123">
					<span id="question-bold-10123">
						What does a typical day working on DevAsk look like?
					</span>
					It’s organized chaos. We hold daily virtual meetings and huddles to
					keep members apprised of progress.
				</p>
				<p id="text-wrap-10123">
					<span id="question-bold-10123">
						What is the one thing you have learnt working on DevAsk?
					</span>
					The importance of collaboration and teamwork. No product can be built
					without smooth integration between members of a team. It`&apos;`s been
					an eye opening experience. Some mistakes have been made but valuable
					lessons are being learned and strong relationships are being built.
				</p>
				<p id="text-wrap-10123">
					<span id="question-bold-10123">
						When you are not working, what do you enjoy doing?
					</span>
					I enjoy self studying. I`&apos;`m currently in a Software Engineering
					boot camp so there`&apos;`s never a day when I`&apos;`m not learning
					something new. I also enjoy playing video games. I want to become a
					gaming developer one day.
				</p>
				<p id="text-wrap-10123">
					<span id="question-bold-10123">
						How would you describe what you do to a 5y/o?{' '}
					</span>
					Digital Marketers bring life to a product through advertising that you
					can see on your favorite platforms such as YouTube, Facebook and
					Instagram to name-10123 a few. When you watch these ads, they make you
					attracted to a product such as a toy and that in turn will make you
					want to buy it. It`&apos;`s great!
				</p>
				<img id="cont-10123" src={contact} alt="web contact" />
				<img id="mcont-10123" src={mcontact} alt="mobile contacts" />
			</div>
		</div>
	);
}

export default Meet;
